if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      // Bemed: Links „Cookie-Einstellungen“ (Seitenfuß, data-cookie-settings) und Links auf
      // #cookie-einstellungen öffnen den Banner erneut, damit die Auswahl geändert oder widerrufen werden kann.
      connectedCallback() {
        super.connectedCallback();

        if (Shopify.designMode) return;

        document.querySelectorAll('[data-cookie-settings-item]').forEach((item) => item.hidden = false);

        this.on(document, 'click', (event) => {
          const link = event.target.closest('[data-cookie-settings], a[href$="#cookie-einstellungen"]');
          if (!link) return;

          event.preventDefault();
          this.openSettings(link);
        });

        const openFromHash = () => {
          if (window.location.hash === '#cookie-einstellungen') this.openSettings();
        };
        this.on(window, 'hashchange', openFromHash);
        openFromHash();
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
        this.bindButtons();
      }

      bindButtons() {
        if (this.buttonsBound) return;
        this.buttonsBound = true;

        if (this.acceptButton) this.on(this.acceptButton, 'click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.on(this.declineButton, 'click', this.declinePolicy.bind(this));
      }

      openSettings(activeElement = null) {
        if (Shopify.designMode) return;

        this.bindButtons();
        this.show(activeElement);
      }
    
      acceptPolicy() {
        this.hide();
        this.setConsent(true);
      }
    
      declinePolicy() {
        this.hide();
        this.setConsent(false);
      }

      // Bemed: Kategorien ausdrücklich setzen, wie es Shopify für das veraltete setTrackingConsent(true/false) tut.
      // „preferences“ gibt auch Google Maps frei (GMap in theme.js).
      setConsent(allowed) {
        const consent = { analytics: allowed, marketing: allowed, preferences: allowed };
        const apply = () => window.Shopify.customerPrivacy?.setTrackingConsent(consent, this.noop);

        if (window.Shopify.customerPrivacy) {
          apply();
        }
        else {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1', onLoad: apply }]);
        }
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
